import moment from 'moment';

export const getThreeWeeks = (date = moment()) => {
  const previous = date.clone().subtract(1, 'isoWeek'),
    next = date.clone().add(1, 'isoWeek');

  const weeks = [previous, date, next].map(day => getWeek(day));

  return weeks;
};

export function getWeek(date = new Date(), currentIsFirst = false) {
  const currentDate = moment(date);

  const weekStart = currentIsFirst
    ? currentDate.clone()
    : currentDate.clone().startOf('isoWeek');

  let days = [];

  for (let i = 0; i <= 6; i++) {
    days.push(moment(weekStart).add(i, 'days'));
  }

  return days;
}
